import { render } from "./model-textarea.html?vue&type=template&id=392a2a8c&scoped=true&ts=true"
import script from "./model-textarea.ts?vue&type=script&lang=ts"
export * from "./model-textarea.ts?vue&type=script&lang=ts"

import "./model-textarea.scss?vue&type=style&index=0&id=392a2a8c&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-392a2a8c"]])

export default __exports__